export enum IndicatorType {
  DisclosedBreaches = "DisclosedBreaches",
  LackingComplianceProcedures = "LackingComplianceProcedures",
  LackingDedicatedPersonnel = "LackingDedicatedPersonnel",
  ConflictMinerals = "ConflictMinerals",
  InternalInvestigations = "InternalInvestigations",
  FinancialSupervision = "FinancialSupervision",
  PEPCRA = "PEPCRA",
  LackingEnvironmentalMeasures = "LackingEnvironmentalMeasures",
  DataOutsideEuEea = "DataOutsideEuEea",
  SubProcessedData = "SubProcessedData",
  Sanctions = "Sanctions",
}

export function indicatorTypeToDescriptionText(
  indicator: IndicatorType
): string {
  switch (indicator) {
    case IndicatorType.DataOutsideEuEea:
      return "Data is transferred or processed on your behalf outside the EU/EEA";
    case IndicatorType.SubProcessedData:
      return "Data is transferred to sub-processor(s).";
    case IndicatorType.DisclosedBreaches:
      return "Units with disclosed breaches";
    case IndicatorType.LackingComplianceProcedures:
      return "Units lacking compliance procedures";
    case IndicatorType.LackingDedicatedPersonnel:
      return "Units lacking dedicated personnel";
    case IndicatorType.ConflictMinerals:
      return "Conflict minerals";
    case IndicatorType.InternalInvestigations:
      return "Units with internal investigations (economic crime)";
    case IndicatorType.FinancialSupervision:
      return "Units under financial supervision";
    case IndicatorType.PEPCRA:
      return "PEP/RCA";
    case IndicatorType.LackingEnvironmentalMeasures:
      return "Units lacking measures to reduce environmental impact and carbon footprint";
    case IndicatorType.Sanctions:
      return "Units subject to Sanctions";
  }
}

export function indicatorTypeToReasonText(reason: IndicatorType): string {
  switch (reason) {
    case IndicatorType.DataOutsideEuEea:
      return "Data outside the EU/EEA";
    case IndicatorType.SubProcessedData:
      return "Sub-processed Data";
    case IndicatorType.DisclosedBreaches:
      return "Disclosed breaches";
    case IndicatorType.LackingComplianceProcedures:
      return "Lacking compliance procedures";
    case IndicatorType.LackingDedicatedPersonnel:
      return "Lacking dedicated personnel";
    case IndicatorType.ConflictMinerals:
      return "Conflict minerals";
    case IndicatorType.InternalInvestigations:
      return "Internal investigations (economic crime)";
    case IndicatorType.FinancialSupervision:
      return "Under financial supervision";
    case IndicatorType.PEPCRA:
      return "PEP (Politically Exposed Person) or RCA (Relatives and Close Associates)";
    case IndicatorType.LackingEnvironmentalMeasures:
      return "Lacking environmental measures";
    case IndicatorType.Sanctions:
      return "Subject to Sanctions";
  }
}
